import { render, staticRenderFns } from "./AuthIFrame.vue?vue&type=template&id=1d474f8b&"
import script from "./AuthIFrame.vue?vue&type=script&lang=js&"
export * from "./AuthIFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports